import * as THREE from 'three';

export const getUvRate = (width, height) => {
  const aspect = width / height;
  return aspect < 1 ? new THREE.Vector2(1, aspect) : new THREE.Vector2(1 / aspect, 1);
};


export const createButton = buttonParams => $(`
    <div class="video-play video-play_small video-play_accent" data-role="video-modal-trigger" data-params='${buttonParams}'></div>
  `);

export const resolveTexture = ({ resolve, texture }) => {
  texture.minFilter = THREE.LinearFilter; // eslint-disable-line no-param-reassign
  // texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy(); // eslint-disable-line no-param-reassign
  resolve(texture);
};



// WEBPACK FOOTER //
// ./scripts/elements/HoverDistortion/helper.js